import { logger } from '../../../common/utils/logger';

export const onPopularSearchQuerySuggestionShown: () =>
	| {
			action: string;
			actionSubject: string;
			eventType: string;
	  }
	| {
			action?: undefined;
			actionSubject?: undefined;
			eventType?: undefined;
	  } = () => {
	try {
		return {
			action: 'shown',
			actionSubject: 'popularSearchQuerySuggestion',
			eventType: 'track',
		};
	} catch (error) {
		logger.error({ error, functionName: 'onPopularSearchQuerySuggestionShown' });
		return {};
	}
};
